import { useState } from 'react';
import { ChevronDown } from 'lucide-react';
import useScrollReveal from '../hooks/useScrollReveal';

const faqs = [
  {
    q: "TIGOO est-il gratuit ?",
    a: "Oui, l'inscription et l'utilisation de base de TIGOO sont entièrement gratuites. Accedez à l'application et commencez à explorer les coupons des meilleurs pronostiqueurs immédiatement.",
  },
  {
    q: "Comment sont classes les pronostiqueurs ?",
    a: "Le classement est base sur les resultats reels et verifies automatiquement. Chaque coupon est suivi et les performances sont calculées de maniere transparente : taux de réussite, ROI, régularité.",
  },
  {
    q: "Comment dévenir pronostiqueur sur TIGOO ?",
    a: "C'est simple ! Creez votre compte, activez le mode pronostiqueur et commencez à publier vos coupons. Votre classement évoluera en fonction de vos résultats réels.",
  },
  {
    q: "Les résultats sont-ils vraiment vérifies ?",
    a: "Absolument. Tous les résultats sont vérifies automatiquement via nos sources de données sportives officielles. Aucune manipulation possible, c'est la transparence totale.",
  },
  {
    q: "Quels sports sont couverts ?",
    a: "Football, basketball, tennis, rugby, formule 1, boxe, MMA, eSport et bien d'autres. Nous couvrons les principales competitions mondiales et nos pronostiqueurs sont spécialisés dans différents sports.",
  },
  {
    q: "Comment recevoir les coupons en temps réel ?",
    a: "Suivez vos pronostiqueurs favoris et activez les notifications. Vous recevrez une alerte instantanee des qu'un nouveau coupon est publié.",
  },
];

function FAQItem({ faq, index }) {
  const [open, setOpen] = useState(false);
  const [ref, isVisible] = useScrollReveal();

  return (
    <div
      className={`faq-item ${open ? 'open' : ''} ${isVisible ? 'visible' : ''}`}
      ref={ref}
      style={{ animationDelay: `${index * 0.08}s` }}
    >
      <button className="faq-question" onClick={() => setOpen(!open)}>
        <span>{faq.q}</span>
        <span className={`faq-chevron ${open ? 'rotated' : ''}`}><ChevronDown size={20} /></span>
      </button>
      <div className="faq-answer">
        <p>{faq.a}</p>
      </div>
    </div>
  );
}

export default function FAQ() {
  const [ref, isVisible] = useScrollReveal();

  return (
    <section id="faq">
      <div className={`faq-header reveal ${isVisible ? 'visible' : ''}`} ref={ref}>
        <span className="section-label">FAQ</span>
        <h2 className="section-title">Questions frequentes</h2>
        <p className="section-sub">Tout ce que vous devez savoir avant de commencer.</p>
      </div>
      <div className="faq-list">
        {faqs.map((faq, i) => (
          <FAQItem key={i} faq={faq} index={i} />
        ))}
      </div>
    </section>
  );
}
